function hideElementsBasedOnDevice() {
    const userAgent = navigator.userAgent;
    const deviceType = 
        /Android|Silk|KF[A-Z]+/i.test(userAgent) ? 'apple-only' : 
        /iPhone|iPad|iPod|Macintosh|MacIntel|MacPPC/i.test(userAgent) ? 'android-only' : 
        null;

    if (deviceType) {
        document.querySelectorAll(`.${deviceType}`).forEach(link => {
            link.style.display = 'none';
        });
    }
}

hideElementsBasedOnDevice();